<script>
import store from '@shared/store'
import settings from '@shared/settings'

export default {
  created() {
    this.$root.$on('enable-biometric-login', this.enableBiometricLogin)
    this.$root.$on('disable-biometric-login', this.disableBiometricLogin)
  },
  destroyed() {
    this.$root.$off('enable-biometric-login', this.enableBiometricLogin)
    this.$root.$off('disable-biometric-login', this.disableBiometricLogin)
  },
  methods: {
    bindEvents() {
      this.unbindEvents()
      this.$root.$on('certificate-exists', this.onCertificateExists)
      this.$root.$on('csr-generated', this.onCsrGenerated)
      this.$root.$on('certificate-stored', this.onCertificateStored)
      this.$root.$on('fallback-to-otp', this.onUserCancelled)
      this.$root.$on('user-cancelled', this.onUserCancelled)
      this.$root.$on('not-available', this.onBiometricLoginError)
      this.$root.$on('authentication-failed', this.onBiometricLoginError)
    },
    unbindEvents() {
      this.$root.$off('certificate-exists', this.onCertificateExists)
      this.$root.$off('csr-generated', this.onCsrGenerated)
      this.$root.$off('certificate-stored', this.onCertificateStored)
      this.$root.$off('fallback-to-otp', this.onUserCancelled)
      this.$root.$off('user-cancelled', this.onUserCancelled)
      this.$root.$off('not-available', this.onBiometricLoginError)
      this.$root.$off('authentication-failed', this.onBiometricLoginError)
    },
    enableBiometricLogin() {
      this.bindEvents()
      const parameters = JSON.stringify(this.customerParameters(this.biometryLabels('loginSetup')))
      if (settings.isAndroid()) {
        window.publicKeyInfrastructure.initializeSigning(parameters)
      } else if (settings.isIOS()) {
        window.webkit.messageHandlers.pkiInitializeSigning.postMessage(parameters)
      }
    },
    disableBiometricLogin() {
      store.setLoginWithBiometryDisabled()
      this.$root.$emit('biometric-login-disabled')
    },
    customerParameters(labels = {}) {
      const customerData = store.state.currentUser
      return {
        firstName: customerData.firstName,
        lastName: customerData.lastName,
        pin: customerData.pin,
        birthDate: customerData.birthDate,
        labels: labels
      }
    },
    biometryLabels(prefix) {
      return {
        title: this.$t(`biometry.${prefix}.title`),
        subtitle: this.$t(`biometry.${prefix}.subtitle`),
        description: this.$t(`biometry.${prefix}.description`),
        cancel: this.$t(`biometry.${prefix}.cancel`)
      }
    },
    onCsrGenerated(csr) {
      const customerData = store.state.currentUser
      this.$http.post(`/api/pki/${customerData.pin}/issue-certificate`, csr).then((response) => {
        const certificate = response.data.certificate
        const parameters = JSON.stringify({ ...this.customerParameters(), certificate })

        if (settings.isAndroid()) {
          window.publicKeyInfrastructure.storeIssuedCertificate(parameters)
        } else if (settings.isIOS()) {
          window.webkit.messageHandlers.pkiStoreIssuedCertificate.postMessage(parameters)
        }
      }).catch(() => {
        this.unbindEvents()
        this.$root.$emit('biometric-login-disabled')
      })
    },
    onCertificateStored() {
      this.unbindEvents()
      store.setLoginWithBiometryEnabled()
      this.$root.$emit('biometric-login-enabled')
    },
    onCertificateExists() {
      this.unbindEvents()
      store.setLoginWithBiometryEnabled()
      this.$root.$emit('biometric-login-enabled')
    },
    onBiometricLoginError() {
      this.unbindEvents()
      store.showBiometricLoginError()
      this.$root.$emit('biometric-login-disabled')
    },
    onUserCancelled() {
      this.unbindEvents()
      this.$root.$emit('biometric-login-disabled')
    }
  }
}
</script>
